<div *ngIf="isSp">
<app-thong-ke-nhap-hoc-sp></app-thong-ke-nhap-hoc-sp>
</div>
<div *ngIf="!isSp">
<app-thong-ke-nhap-hoc></app-thong-ke-nhap-hoc>
</div>